"use client";
import { useEffect, useState } from "react";
import Script from 'next/script'
import env from '.env.json';

export default function Analytics() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    let triggered = false;

    const loadAnalytics = () => {
      if (!triggered) {
        triggered = true;
        setShouldLoad(true);
        window.removeEventListener("scroll", loadAnalytics);
        window.removeEventListener("mousemove", loadAnalytics);
        window.removeEventListener("click", loadAnalytics);
        clearTimeout(timeout);
      }
    };

    // trigger khi có tương tác
    window.addEventListener("scroll", loadAnalytics);
    window.addEventListener("mousemove", loadAnalytics);
    window.addEventListener("click", loadAnalytics);

    // fallback: auto load sau 5 giây
    timeout = setTimeout(loadAnalytics, 5000);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("scroll", loadAnalytics);
      window.removeEventListener("mousemove", loadAnalytics);
      window.removeEventListener("click", loadAnalytics);
    };
  }, []);

  if (!shouldLoad) return null;

  return (
    <>
      <Script
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtag/js?id=${env.NEXT_PUBLIC_GOOGLE_ANALYTICS}`}
      />
      <Script
        id="gtag-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${env.NEXT_PUBLIC_GOOGLE_ANALYTICS}', {
            page_path: window.location.pathname,
          });
        `,
        }}
      />
    </>
  );
}
